import { User } from '@types'
import { client } from './client'
import { SuccessForm } from '@views/tracking/modals/EditStagesModal'

export const profileService = async (userId: string, cocap: string): Promise<{ parent: User; person: User }> => {
  const { data } = await client.get(`/person/${userId}`, {
    headers: {
      cocap
    }
  })
  return data
}

export const verifyProfileService = async (userId: string, cocap: string) => {
  const { data } = await client.patch(
    '/user/verify',
    {
      userId,
      isVerified: true
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export const patchUserService = async (user: Partial<User>, cocap: string) => {
  const { data } = await client.patch(
    `/person/${user._id}`,
    {
      ...user
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export const setSuccessUserService = async (user: User, successData: SuccessForm, cocap: string) => {
  const { data } = await client.patch(
    `/person/success/${user._id}`,
    {
      user,
      successData
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export const deleteUserService = async (userId: string, cocap: String) => {
  const { data } = await client.delete(`/person/${userId}`, {
    headers: {
      cocap
    }
  })
  return data
}

export const sendSuccessService = async (userId: string, cocap: String) => {
  const { data } = await client.post(
    `/person/success/${userId}`,
    {},
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export const queryNameService = async (searchQuery: string, cocap: string): Promise<{ parent: User; person: User }> => {
  const { data } = await client.get(`/person/query?name=${searchQuery}`, {
    headers: {
      cocap
    }
  })
  return data
}

export const relocateService = async (newParentId: string, oldParentId: string, personId: string, cocap: string) => {
  const { data } = await client.put(
    '/person/relocate',
    {
      newParentId,
      oldParentId,
      personId
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export const patchAccountDataService = async (
  userId: string,
  accountData: {
    accountNumber?: number | string
    bankName?: string
    accountType?: string
    accountDocument?: string
    accountDocumentLink?: string
    physicalAddress?: string
    rutDocument?: string
  },
  cocap: string
) => {
  const { data } = await client.put(
    `/person/account-data/${userId}`,
    {
      accountData
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}
